import {
    Card,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { TextField } from '@components/form/fields';

import { formatCurrencyInBDT } from '@/utils';

import { useCreateSalesReturnContext } from './create-sales-return.context';
import { CreateSalesReturnForm } from './schema';

export const Items = () => {
    const { orderData, orderId, isLoading, isOrderFetching, isOrderError } =
        useCreateSalesReturnContext();

    const { control, watch } = useFormContext<CreateSalesReturnForm>();

    const { update } = useFieldArray({
        control,
        name: 'items',
    });

    const items = watch('items');

    if (isLoading || isOrderFetching) {
        return (
            <Card className={'p-4'}>
                <div className={'flex items-center justify-center py-6'}>
                    Loading items...
                </div>
            </Card>
        );
    }

    if (isOrderError) {
        return (
            <Card className={'p-4'}>
                <div className={'flex items-center justify-center py-6'}>
                    Failed to load order items. Please try again.
                </div>
            </Card>
        );
    }

    if (!orderData || !orderId) {
        return (
            <Card className={'p-4'}>
                <div className={'flex items-center justify-center py-6'}>
                    Please select an order to see the items.
                </div>
            </Card>
        );
    }

    if (orderData?.data?.items?.length === 0) {
        return (
            <Card className={'p-4'}>
                <div className={'flex items-center justify-center py-6'}>
                    No items found in this order.
                </div>
            </Card>
        );
    }

    return (
        <Card className={'p-4'}>
            <h2 className={'text-lg font-medium'}>Items</h2>

            {/*<Table>*/}
            {/*    <TableHeader>*/}
            {/*        <TableRow>*/}
            {/*            <TableHead className="w-[50px]"></TableHead>*/}
            {/*            <TableHead>Name</TableHead>*/}
            {/*            <TableHead className={'text-right'}>Price</TableHead>*/}
            {/*            <TableHead className="text-right">Quantity</TableHead>*/}
            {/*            <TableHead className="text-right">*/}
            {/*                Return Quantity*/}
            {/*            </TableHead>*/}
            {/*            <TableHead className="text-right">Total</TableHead>*/}
            {/*        </TableRow>*/}
            {/*    </TableHeader>*/}
            {/*    <TableBody>*/}
            {/*        {orderData?.data?.items.map((item, index) => (*/}
            {/*            <TableRow key={item.id}>*/}
            {/*                <TableCell className="font-medium">*/}
            {/*                    <Checkbox*/}
            {/*                        onCheckedChange={(checkedState) => {*/}
            {/*                            if (checkedState === false) {*/}
            {/*                                const index = getValues(*/}
            {/*                                    'items',*/}
            {/*                                ).findIndex(*/}
            {/*                                    (i) => i.itemId === item.id,*/}
            {/*                                );*/}
            {/*                                if (index !== -1) {*/}
            {/*                                    remove(index);*/}
            {/*                                }*/}
            {/*                                return;*/}
            {/*                            }*/}

            {/*                            if (*/}
            {/*                                !item ||*/}
            {/*                                !item.quantity ||*/}
            {/*                                !item.price ||*/}
            {/*                                !item.id ||*/}
            {/*                                !item.product_name*/}
            {/*                            ) {*/}
            {/*                                return;*/}
            {/*                            }*/}

            {/*                            append({*/}
            {/*                                itemId: item.id,*/}
            {/*                                productName: item.product_name,*/}
            {/*                                price: item.price,*/}
            {/*                                quantity: item.quantity,*/}
            {/*                                rate: item.price,*/}
            {/*                            });*/}
            {/*                        }}*/}
            {/*                    />*/}
            {/*                </TableCell>*/}
            {/*                <TableCell>{item.product_name}</TableCell>*/}
            {/*                <TableCell className={'text-right'}>*/}
            {/*                    {formatCurrencyInBDT(item.price)}*/}
            {/*                </TableCell>*/}
            {/*                <TableCell className="text-right">*/}
            {/*                    {item.quantity}*/}
            {/*                </TableCell>*/}

            {/*                <TableCell className="text-right">*/}
            {/*                    {items.findIndex((i) => i.itemId === item.id) !=*/}
            {/*                    -1 ? (*/}
            {/*                        <TextField<CreateSalesReturnForm>*/}
            {/*                            name={`items.${index}.quantity`}*/}
            {/*                            className={'text-right'}*/}
            {/*                        />*/}
            {/*                    ) : null}*/}
            {/*                </TableCell>*/}

            {/*                <TableCell className={'text-right'}>*/}
            {/*                    {formatCurrencyInBDT(*/}
            {/*                        item.price * item.quantity,*/}
            {/*                    )}*/}
            {/*                </TableCell>*/}
            {/*            </TableRow>*/}
            {/*        ))}*/}
            {/*    </TableBody>*/}
            {/*</Table>*/}

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="w-[50px]"></TableHead>
                        <TableHead>Name</TableHead>
                        <TableHead className={'text-right'}>Price</TableHead>
                        <TableHead className="text-right">Quantity</TableHead>
                        <TableHead className="text-right">
                            Return Quantity
                        </TableHead>
                        <TableHead className="text-right">Total</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {items?.map((item, index) => (
                        <TableRow key={item.itemId}>
                            <TableCell>
                                <Checkbox
                                    onCheckedChange={(checkedState) => {
                                        update(index, {
                                            ...item,
                                            isSelected: Boolean(checkedState),
                                        });
                                    }}
                                />
                            </TableCell>

                            <TableCell>{item.itemName}</TableCell>

                            <TableCell className={'text-right'}>
                                {formatCurrencyInBDT(item.price)}
                            </TableCell>

                            <TableCell className={'text-right'}>
                                {item.quantity}
                            </TableCell>

                            <TableCell className="text-right">
                                <TextField<CreateSalesReturnForm>
                                    inputClass={'text-right'}
                                    disabled={!item.isSelected}
                                    type={'number'}
                                    name={`items.${index}.returnQuantity`}
                                />
                            </TableCell>

                            <TableCell className={'text-right'}>
                                {formatCurrencyInBDT(
                                    item.price * item.returnQuantity,
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
};

Items.displayName = 'Items';
